//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';
import { IProfession } from 'src/app/shared/interfaces/profession/iprofession';

//padrão de nomenclatura tudo maiusculo
enum ProfessionActionType {
  //textos para acomparnharmos os estados de load profession
  LOAD_PROFESSION = '[profession] load profession from api',
  LOAD_PROFESSION_SUCCESS = '[profession] load profession from api return success',
  LOAD_PROFESSION_ERROR = '[profession] load profession from api return error',
  SAVE_PROFESSION = '[profession] save profession from api',
  SAVE_PROFESSION_SUCCESS = '[profession] edit profession from api return success',
  EDIT_PROFESSION = '[profession] edit profession from api',
  EDIT_PROFESSION_SUCCESS = '[profession] edit profession from api return success',
  DELETE_PROFESSION = '[profession] delete profession from api',
}
export const loadProfessionFilter = createAction(
  ProfessionActionType.LOAD_PROFESSION,
  props<{ professionCategory: string }>()
);

export const loadProfession = createAction(
  ProfessionActionType.LOAD_PROFESSION
);

export const loadProfessionSuccess = createAction(
  ProfessionActionType.LOAD_PROFESSION_SUCCESS,
  props<{ lista: IProfession[] }>()
);
//vai para o effects
export const saveProfession = createAction(
  ProfessionActionType.SAVE_PROFESSION,
  props<{ profession: IProfession }>()
);
//vai para o reducer
export const saveProfessionSuccess = createAction(
  ProfessionActionType.SAVE_PROFESSION_SUCCESS,
  props<{ profession: IProfession }>()
);
//vai para o effects
export const editProfession = createAction(
  ProfessionActionType.EDIT_PROFESSION,
  props<{ profession: IProfession; id: number }>()
);
//vai para o reducer
export const editProfessionSuccess = createAction(
  ProfessionActionType.EDIT_PROFESSION_SUCCESS,
  props<{ profession: IProfession }>()
);

export const deleteProfession = createAction(
  ProfessionActionType.DELETE_PROFESSION,
  props<{ id: number }>()
);
